import { service } from ".";

export default {
  getAll: () => service.get("/departments"),
  getOne: (id) => service.get(`/departments/${id}`),
  getAllPaginate: (query) => service.get(`/departments/paginate?${query}`),
  create: (data) => service.post("/departments", data),
  update: (id, data) => service.put(`/departments/${id}`, data),
  delete: (id) => service.delete(`/departments/${id}`),
};
